/* Laali's welcome — a one-time hello from the Purkal dog.
   Config and image URLs come off the #pk-laali-config node that
   sections/purkal-laali.liquid renders. Styles live in purkal.css. */
(function () {
  'use strict';

  var SEEN_KEY = 'pk:laali-seen';
  var ARM_KEY = 'pk:laali-arm';
  var PENDING_KEY = 'pk:laali-pending';
  /* Anywhere the visitor is already converting or already known to us. */
  var SKIP_PATHS = [/\/checkouts?\//i, /\/thank_you/i, /\/cart(\/|$|\?)/i, /\/account/i];
  var RUBBING = ['More!', 'So good!', 'Almost there!', 'I could do this all day.'];

  var root = document.getElementById('pk-laali-config');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var CFG = {
    walk: root.dataset.walk,
    belly: root.dataset.belly,
    delay: parseInt(root.dataset.delay, 10) * 1000,
    repeatDays: parseInt(root.dataset.repeatDays, 10),
    pats: 2,
    rubNeeded: 170,
    tags: root.dataset.tags || 'newsletter',
    exitIntent: root.dataset.exitIntent === '1',
    skipWithCart: root.dataset.skipWithCart === '1',
    skipCustomers: root.dataset.skipCustomers === '1',
    cartCount: parseInt(root.dataset.cartCount, 10) || 0,
    isCustomer: root.dataset.customer === '1',
    askStyle: root.dataset.askStyle || 'pat'
  };


  /* She is asking a browser to leave an email. Someone with a cart is past
     that — they are trying to buy, and the ask would only be in the way. */
  function suppressed() {
    if (CFG.skipWithCart && CFG.cartCount > 0) return true;
    if (CFG.skipCustomers && CFG.isCustomer) return true;
    return false;
  }

  for (var i = 0; i < SKIP_PATHS.length; i++) {
    if (SKIP_PATHS[i].test(location.pathname)) return;
  }

  var store = {
    get: function (k) {
      try {
        return localStorage.getItem(k);
      } catch (e) {
        return null;
      }
    },
    set: function (k, v) {
      try {
        localStorage.setItem(k, v);
      } catch (e) {
        /* private browsing — she just says hello every visit */
      }
    }
  };

  /* Which version of the ask this visitor gets. Under 'split' the coin is
     tossed once and remembered, so a visitor never sees the popup change
     shape on them, and the signup carries the arm as a tag — that tag is
     how the two are compared in Shopify afterwards. */
  var ARM = (function () {
    if (CFG.askStyle !== 'split') return CFG.askStyle === 'direct' ? 'direct' : 'pat';
    var held = store.get(ARM_KEY);
    if (held === 'pat' || held === 'direct') return held;
    var arm = Math.random() < 0.5 ? 'pat' : 'direct';
    store.set(ARM_KEY, arm);
    return arm;
  })();

  /* Once per visitor. A repeatDays of 0 means never ask again. */
  function alreadySeen() {
    var at = parseInt(store.get(SEEN_KEY), 10);
    if (!at) return false;
    if (!CFG.repeatDays) return true;
    return Date.now() - at < CFG.repeatDays * 864e5;
  }

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pick(a) {
    return a[Math.floor(Math.random() * a.length)];
  }
  function rand(a, b) {
    return a + Math.random() * (b - a);
  }
  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  var modal = null;
  var stepEl = null;
  var petBox = null;

  /* ------------------------------------------------------------- shell */
  function open(step) {
    modal = el('div', 'pk pk-laali');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'A hello from Laali');

    var card = el('div', 'pk-laali__card');
    var x = el('button', 'pk-laali__x', '✕');
    x.type = 'button';
    x.setAttribute('aria-label', 'Close');
    x.onclick = close;

    stepEl = el('div');
    card.appendChild(x);
    card.appendChild(stepEl);
    modal.appendChild(card);
    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';

    requestAnimationFrame(function () {
      modal.classList.add('is-open');
    });
    document.addEventListener('keydown', onKey);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) close();
    });

    (step || introStep)();
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
  }

  function close() {
    if (!modal) return;
    /* Hand the live form back before the modal is torn down around it. */
    stashForm();
    store.set(SEEN_KEY, String(Date.now()));
    modal.classList.remove('is-open');
    document.removeEventListener('keydown', onKey);
    document.body.style.overflow = '';
    var node = modal;
    modal = null;
    setTimeout(function () {
      node.remove();
    }, 320);
  }


  /* ------------------------------------------------------- the live form
     The signup form is rendered by Liquid and moved around the DOM, never
     rebuilt — Shopify only binds its CAPTCHA to forms it rendered itself.
     Every step therefore parks it back in its host before clearing. */
  function formHost() {
    return document.getElementById('pk-laali-form-host');
  }
  function stashForm() {
    if (!stepEl) return;
    var f = stepEl.querySelector('form');
    var host = formHost();
    if (f && host) host.appendChild(f);
  }
  function takeForm() {
    var host = formHost();
    return host ? host.querySelector('form') : null;
  }
  function bindForm(form) {
    if (form.dataset.pkBound) return;
    form.dataset.pkBound = '1';
    form.addEventListener('submit', function () {
      /* The arm rides along as a customer tag, which is the whole basis of
         comparing the two versions later. */
      var tags = form.querySelector('input[name="contact[tags]"]');
      if (tags && tags.value.indexOf('laali-' + ARM) === -1) {
        tags.value = tags.value + ', laali-' + ARM;
      }
      /* Native submit, so Shopify's CAPTCHA runs and the page navigates.
         Flag the trip so we can reopen on the success step when it returns. */
      store.set(SEEN_KEY, String(Date.now()));
      try {
        /* Timestamp, so the resume can ignore a stale flag. */
        sessionStorage.setItem(PENDING_KEY, String(Date.now()));
      } catch (e) {
        /* the signup still completes; only the success step is lost */
      }
      var btn = form.querySelector('button[type="submit"]');
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Letting you in…';
      }
    });
  }

  /* --------------------------------------------------------- the hello */
  function introStep() {
    if (ARM === 'direct') return directStep();
    stashForm();
    stepEl.innerHTML = '';

    var img = el('img', 'pk-laali__walk');
    img.src = CFG.walk;
    img.alt = 'Laali, our German Shepherd, trotting over';
    img.draggable = false;
    stepEl.appendChild(img);

    stepEl.appendChild(el('h2', null, 'Hi, I’m Laali! 🐾'));
    stepEl.appendChild(el('div', 'pk-laali__tag', 'The actual boss of Purkal.'));
    stepEl.appendChild(el('div', 'pk-laali__rule', '♥'));
    stepEl.appendChild(el('div', 'pk-laali__sub', 'You look like someone who loves handmade things.'));
    stepEl.appendChild(
      el(
        'div',
        'pk-laali__ask',
        'Pat me twice and join the pack!<br><span>I’ll send you a little note from our workshop each month.</span>'
      )
    );

    var yes = el('button', 'pk-laali__btn', 'Of course! ❤️');
    yes.type = 'button';
    yes.onclick = patStep;
    stepEl.appendChild(yes);

    var no = el('button', 'pk-laali__no', 'Maybe next time, Laali');
    no.type = 'button';
    no.onclick = close;
    stepEl.appendChild(no);

    stepEl.appendChild(el('div', 'pk-laali__foot', '🐾 Just a little Purkal love. No spam.'));
    yes.focus({ preventScroll: true });
  }

  /* ----------------------------------------------------------- the pat */
  function patStep() {
    stashForm();
    stepEl.innerHTML = '';
    stepEl.appendChild(el('h2', null, 'Pat me first!'));
    stepEl.appendChild(el('div', 'pk-laali__sub', 'Two pats will do it — or give my belly a good rub.'));

    petBox = el('div', 'pk-laali__pet');
    var img = el('img');
    img.src = CFG.belly;
    img.alt = 'Laali rolled onto her back, waiting for a belly rub';
    img.draggable = false;
    petBox.appendChild(img);
    stepEl.appendChild(petBox);

    var bar = el('div', 'pk-laali__bar');
    var fill = el('i');
    bar.appendChild(fill);
    stepEl.appendChild(bar);

    var note = el('div', 'pk-laali__note', '');
    stepEl.appendChild(note);

    var total = 0;
    var last = null;
    var active = false;
    var done = false;
    var said = -1;
    var perPat = CFG.rubNeeded / CFG.pats;

    function progress() {
      var p = Math.min(total / CFG.rubNeeded, 1);
      fill.style.width = p * 100 + '%';
      var idx = Math.min(Math.floor(p * RUBBING.length), RUBBING.length - 1);
      if (p > 0 && idx !== said) {
        said = idx;
        note.textContent = RUBBING[idx];
      }
      if (p >= 1 && !done) {
        done = true;
        satisfied();
      }
    }

    function heart(x, y) {
      if (REDUCED) return;
      var h = el('span', 'pk-laali__heart', Math.random() < 0.72 ? '❤️' : '✨');
      h.style.left = x + 'px';
      h.style.top = y + 'px';
      h.style.setProperty('--pk-dx', rand(-24, 24) + 'px');
      petBox.appendChild(h);
      setTimeout(function () {
        h.remove();
      }, 1100);
    }

    function start(e) {
      active = true;
      petBox.classList.add('is-grabbing', 'is-active');
      last = { x: e.clientX, y: e.clientY };
      var r = petBox.getBoundingClientRect();
      heart(e.clientX - r.left, e.clientY - r.top);
      total += perPat; // a pat on its own is plenty
      progress();
    }

    function move(e) {
      if (!active || done) return;
      if (last) {
        var d = Math.hypot(e.clientX - last.x, e.clientY - last.y);
        total += Math.min(d, 90); // clamp jumps, never discard a fast rub
        if (d > 7) {
          var r = petBox.getBoundingClientRect();
          heart(e.clientX - r.left, e.clientY - r.top);
        }
        progress();
      }
      last = { x: e.clientX, y: e.clientY };
    }

    function stop() {
      active = false;
      last = null;
      petBox.classList.remove('is-grabbing', 'is-active');
    }

    petBox.addEventListener('pointerdown', function (e) {
      e.preventDefault();
      start(e);
    });
    petBox.addEventListener('pointermove', move);
    petBox.addEventListener('pointerleave', stop);
    window.addEventListener('pointerup', stop);

    var kb = el('button', 'pk-laali__kb', 'or pat her with the keyboard');
    kb.type = 'button';
    kb.setAttribute('aria-label', 'Pat Laali');
    kb.onclick = function () {
      total += perPat;
      progress();
    };
    stepEl.appendChild(kb);
  }

  function satisfied() {
    petBox.classList.add('is-done');
    petBox.classList.remove('is-active');
    /* Full drop the moment she's had enough pats — the payoff for the rub. */
    scraps(70);
    setTimeout(rewardStep, REDUCED ? 150 : 850);
  }

  /* -------------------------------------------------------- the reward */
  function rewardStep() {
    stashForm();
    stepEl.innerHTML = '';
    stepEl.appendChild(el('h2', null, 'You made my day ❤️'));
    stepEl.appendChild(
      el(
        'div',
        'pk-laali__sub',
        'Join the pack and I’ll write to you — new pieces, the stories behind them, and what the Didis are stitching.'
      )
    );

    /* Move the Liquid-rendered form in rather than building one. Shopify only
       attaches its CAPTCHA to forms it rendered, and moving the live node
       keeps those bindings intact. */
    var form = takeForm();

    if (!form) {
      /* Section markup missing — say so plainly instead of a dead button. */
      stepEl.appendChild(
        el('div', 'pk-laali__err', 'The sign-up form isn’t available right now. Sorry!')
      );
      return;
    }

    stepEl.appendChild(form);

    stepEl.appendChild(el('div', 'pk-laali__err', ''));
    bindForm(form);
  }

  /* ------------------------------------------------- the hello, email first
     Same greeting, but the field is on the first screen: nothing stands
     between a visitor on their way out and the one thing we want. The pat
     stays on offer underneath, as delight rather than a toll gate. */
  function directStep() {
    stashForm();
    stepEl.innerHTML = '';

    var img = el('img', 'pk-laali__walk');
    img.src = CFG.walk;
    img.alt = 'Laali, our German Shepherd, trotting over';
    img.draggable = false;
    stepEl.appendChild(img);

    stepEl.appendChild(el('h2', null, 'Hi, I’m Laali! 🐾'));
    stepEl.appendChild(el('div', 'pk-laali__tag', 'The actual boss of Purkal.'));
    stepEl.appendChild(el('div', 'pk-laali__rule', '♥'));
    stepEl.appendChild(
      el(
        'div',
        'pk-laali__sub',
        'Join the pack and I’ll write once a month — new pieces, and the stories behind them.'
      )
    );

    var form = takeForm();
    if (!form) {
      stepEl.appendChild(
        el('div', 'pk-laali__err', 'The sign-up form isn’t available right now. Sorry!')
      );
      return;
    }
    stepEl.appendChild(form);
    stepEl.appendChild(el('div', 'pk-laali__err', ''));
    bindForm(form);

    var pat = el('button', 'pk-laali__kb', 'or pat me first 🐾');
    pat.type = 'button';
    pat.onclick = patStep;
    stepEl.appendChild(pat);

    var no = el('button', 'pk-laali__no', 'Maybe next time, Laali');
    no.type = 'button';
    no.onclick = close;
    stepEl.appendChild(no);

    stepEl.appendChild(el('div', 'pk-laali__foot', '🐾 Just a little Purkal love. No spam.'));

    var name = form.querySelector('#pk-laali-name');
    if (name) name.focus({ preventScroll: true });
  }

  function doneStep() {
    stashForm();
    stepEl.innerHTML = '';
    stepEl.appendChild(el('h2', null, 'You’re in the pack ❤️'));
    stepEl.appendChild(
      el(
        'div',
        'pk-laali__sub',
        'One letter a month, from the workshop in Dehradun. Leave the pack any time — no hard feelings, I promise.'
      )
    );
    var go = el('button', 'pk-laali__btn', 'Back to browsing');
    go.type = 'button';
    go.onclick = function () {
      close();
      /* Start them at the top rather than wherever the signup round trip
         left the page. Only on this step — dismissing her mid-browse
         should leave the scroll position alone. */
      window.scrollTo(0, 0);
    };
    stepEl.appendChild(go);
    go.focus({ preventScroll: true });

    /* The actual celebration: they joined the pack. */
    scraps(70);
  }

  /* Coming back from a Laali signup: pick the modal up at the last step.

     Keyed on our own flag, not on ?customer_posted=true. Shopify does not
     reliably put that parameter on the URL it returns to, and requiring it
     meant the success step — and its confetti — silently never ran. The flag
     is written the moment the form is submitted, so it also distinguishes
     Laali's signup from the footer newsletter's. */
  function resumeAfterSignup() {
    var at = null;
    try {
      at = sessionStorage.getItem(PENDING_KEY);
      sessionStorage.removeItem(PENDING_KEY);
    } catch (e) {
      return false;
    }
    if (!at) return false;

    /* Only just submitted — a stale flag shouldn't congratulate someone
       several pages later. */
    if (Date.now() - parseInt(at, 10) > 120000) return false;

    /* Tidy the URL so a refresh doesn't replay the success step, and drop the
       #PurkalLaali anchor with it: the form lives in this section, which sits
       last on the page, so returning to that anchor dumps the visitor at the
       very bottom. */
    if (window.history && history.replaceState) {
      history.replaceState({}, '', location.pathname);
    }
    window.scrollTo(0, 0);

    open(doneStep);
    return true;
  }

  /* ------------------------------------------------------------ confetti */
  function scraps(n) {
    if (REDUCED) return;
    var cols = ['#771619', '#d6a13b', '#5c7a54', '#33506b', '#e8dcc3', '#b8382a', '#c98a5b'];
    for (var i = 0; i < n; i++) {
      var s = el('div', 'pk-laali-scrap');
      s.style.width = rand(7, 15) + 'px';
      s.style.height = rand(6, 12) + 'px';
      s.style.left = rand(0, 100) + 'vw';
      s.style.background = pick(cols);
      s.style.opacity = rand(0.75, 1);
      s.style.setProperty('--pk-spin', (Math.random() < 0.5 ? '' : '-') + rand(320, 760) + 'deg');
      s.style.animation = 'pk-laali-fall ' + rand(2.4, 4.4) + 's linear ' + rand(0, 0.9) + 's forwards';
      document.body.appendChild(s);
      (function (node) {
        setTimeout(function () {
          node.remove();
        }, 6000);
      })(s);
    }
  }

  /* -------------------------------------------------------------- trigger
     A plain timer fires while someone is still shopping, which is the worst
     moment to ask for an email. So the timer is only the backstop: the real
     trigger is the visitor showing they are on their way out. */
  var timer = 0;
  var fired = false;
  var deepest = 0;
  var lastY = 0;
  var lastT = 0;

  function fire() {
    if (fired || modal) return;
    fired = true;
    disarm();
    open();
  }

  /* Desktop: the cursor leaving through the top of the window is the visitor
     reaching for the address bar, a bookmark, or the close button. */
  function onExit(e) {
    if (e.clientY > 6) return;
    if (e.relatedTarget || e.toElement) return;
    fire();
  }

  /* Phones have no cursor to read. The equivalent tell is a hard flick back
     up a page they had already scrolled down — done looking, heading out. */
  function onScroll() {
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var now = Date.now();
    if (y > deepest) deepest = y;
    if (deepest > 900 && y < lastY - 260 && now - lastT < 420) fire();
    lastY = y;
    lastT = now;
  }

  function disarm() {
    clearTimeout(timer);
    document.removeEventListener('mouseout', onExit);
    window.removeEventListener('scroll', onScroll);
  }

  function arm() {
    /* Preload both poses so neither pops in half-drawn. */
    new Image().src = CFG.walk;
    new Image().src = CFG.belly;
    timer = setTimeout(fire, CFG.delay);
    if (CFG.exitIntent) {
      document.addEventListener('mouseout', onExit);
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  /* In the theme editor she waits to be summoned — a modal that reopens on
     every reload makes the section impossible to edit. Selecting the section
     in the sidebar shows her. */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:select', function (e) {
      if (root.closest('.shopify-section') === e.target && !modal) open();
    });
    document.addEventListener('shopify:section:deselect', close);
  } else if (!resumeAfterSignup() && !alreadySeen() && !suppressed()) {
    /* resumeAfterSignup wins: signing up marks her seen, so the ordinary
       gate would otherwise swallow the success step on the way back. */
    arm();
  }

  /* QA hooks: Laali.show() to summon her, Laali.reset() to forget the visit. */
  window.Laali = {
    show: function () {
      disarm();
      if (!modal) open();
    },
    close: close,
    reset: function () {
      try {
        localStorage.removeItem(SEEN_KEY);
      } catch (e) {
        /* nothing to forget */
      }
    }
  };
})();
